import { CSSProperties } from 'react';

export default function Boxless({ s }: { s?: CSSProperties }) {
  return (
    <svg
      width="32"
      height="30"
      viewBox="0 0 32 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ ...s, verticalAlign: 'middle' }}
    >
      <path
        fillRule="evenodd"
        d="M10.9813 29.6739H21.3163C22.9725 29.6739 24.2975 28.3696 24.2975 26.7391V3.39129C24.2975 1.76086 22.9725 0.456512 21.3163 0.456512H10.9813C9.32503 0.456512 8.00003 1.76086 8.00003 3.39129V26.7391C8.00003 28.3696 9.32503 29.6739 10.9813 29.6739ZM8.66253 3.3913C8.66253 2.15216 9.72253 1.10869 10.9813 1.10869H21.3163C22.575 1.10869 23.635 2.15216 23.635 3.3913V26.7391C23.635 27.9783 22.575 29.0217 21.3163 29.0217H10.9813C9.72253 29.0217 8.66253 27.9783 8.66253 26.7391V3.3913Z"
        fill="black"
      />
      <ellipse
        cx="16.1488"
        cy="26.0869"
        rx="1.12625"
        ry="1.1087"
        fill="#ECECEC"
      />
      <path
        fillRule="evenodd"
        d="M14.6913 26.0217C14.6913 26.8043 15.3538 27.4565 16.1488 27.4565C16.9438 27.4565 17.6063 26.8043 17.6063 26.0217C17.6063 25.2391 16.9438 24.5869 16.1488 24.5869C15.3538 24.5869 14.6913 25.2391 14.6913 26.0217ZM15.3538 26.0869C15.3538 25.6304 15.685 25.3043 16.1488 25.3043C16.6125 25.3043 16.9438 25.6304 16.9438 26.0869C16.9438 26.5435 16.6125 26.8696 16.1488 26.8696C15.685 26.8696 15.3538 26.5435 15.3538 26.0869Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        d="M10.5838 13.7609H14.4925C14.6913 13.7609 14.8238 13.6304 14.8238 13.4348V9.58695C14.8238 9.3913 14.6913 9.26086 14.4925 9.26086H10.5838C10.385 9.26086 10.2525 9.3913 10.2525 9.58695V13.4348C10.2525 13.6304 10.385 13.7609 10.5838 13.7609ZM14.1613 13.1087H10.915V9.91304H14.1613V13.1087Z"
        fill="black"
      />
      <path
        d="M12.8363 12.1304H12.3063C12.1075 12.1304 11.975 12 11.975 11.8043V11.2826C11.975 11.0869 12.1075 10.9565 12.3063 10.9565H12.8363C13.035 10.9565 13.1675 11.0869 13.1675 11.2826V11.8043C13.1675 11.9348 12.9688 12.1304 12.8363 12.1304Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        d="M10.5838 20.8696H14.4925C14.6913 20.8696 14.8238 20.7391 14.8238 20.5435V16.6957C14.8238 16.5 14.6913 16.3696 14.4925 16.3696H10.5838C10.385 16.3696 10.2525 16.5 10.2525 16.6957V20.5435C10.2525 20.7391 10.385 20.8696 10.5838 20.8696ZM14.1613 20.2174H10.915V17.0217H14.1613V20.2174Z"
        fill="black"
      />
      <path
        d="M12.8363 19.2391H12.3063C12.1075 19.2391 11.975 19.1087 11.975 18.913V18.3913C11.975 18.1957 12.1075 18.0652 12.3063 18.0652H12.8363C13.035 18.0652 13.1675 18.1957 13.1675 18.3913V18.913C13.1675 19.1087 12.9688 19.2391 12.8363 19.2391Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        d="M17.805 13.7609H21.7138C21.9125 13.7609 22.045 13.6304 22.045 13.4348V9.58695C22.045 9.3913 21.9125 9.26086 21.7138 9.26086H17.805C17.6063 9.26086 17.4738 9.3913 17.4738 9.58695V13.4348C17.4738 13.6304 17.6063 13.7609 17.805 13.7609ZM21.3825 13.1087H18.1363V9.91304H21.3825V13.1087Z"
        fill="black"
      />
      <path
        d="M20.0575 12.1304H19.5275C19.3288 12.1304 19.1963 12 19.1963 11.8043V11.2826C19.1963 11.0869 19.3288 10.9565 19.5275 10.9565H20.0575C20.2563 10.9565 20.3888 11.0869 20.3888 11.2826V11.8043C20.3888 11.9348 20.2563 12.1304 20.0575 12.1304Z"
        fill="black"
      />
      <path
        d="M16.1488 17.6087C15.95 17.6087 15.8175 17.4783 15.8175 17.2826V15.3913H11.71C11.5113 15.3913 11.3788 15.2609 11.3788 15.0652C11.3788 14.8696 11.5113 14.7391 11.71 14.7391H16.1488C16.3475 14.7391 16.48 14.8696 16.48 15.0652V17.2826C16.48 17.4783 16.3475 17.6087 16.1488 17.6087Z"
        fill="black"
      />
      <path
        d="M16.1488 10.4348C15.95 10.4348 15.8175 10.3043 15.8175 10.1087V9.58695C15.8175 9.3913 15.95 9.26086 16.1488 9.26086C16.3475 9.26086 16.48 9.3913 16.48 9.58695V10.1087C16.48 10.3043 16.3475 10.4348 16.1488 10.4348Z"
        fill="black"
      />
      <path
        d="M16.1488 13.7608C15.95 13.7608 15.8175 13.6304 15.8175 13.4348V11.8043C15.8175 11.6087 15.95 11.4782 16.1488 11.4782C16.3475 11.4782 16.48 11.6087 16.48 11.8043V13.4348C16.48 13.6304 16.3475 13.7608 16.1488 13.7608Z"
        fill="black"
      />
      <path
        d="M19.5275 19.2391H17.8713C17.6725 19.2391 17.54 19.1087 17.54 18.913C17.54 18.7174 17.6725 18.587 17.8713 18.587H19.1963V18.3913C19.1963 18.1957 19.3288 18.0652 19.5275 18.0652C19.7263 18.0652 19.8588 18.1957 19.8588 18.3913V18.913C19.8588 19.1087 19.66 19.2391 19.5275 19.2391Z"
        fill="black"
      />
      <path
        d="M21.7138 20.8695H19.4613C19.2625 20.8695 19.13 20.7391 19.13 20.5435C19.13 20.3478 19.2625 20.2174 19.4613 20.2174H21.3825V17.8043C21.3825 17.6087 21.515 17.4782 21.7138 17.4782C21.9125 17.4782 22.045 17.6087 22.045 17.8043V20.5435C22.045 20.7391 21.9125 20.8695 21.7138 20.8695Z"
        fill="black"
      />
      <path
        d="M17.805 3.32606H14.4263C14.2275 3.32606 14.095 3.19563 14.095 2.99998C14.095 2.80432 14.2275 2.67389 14.4263 2.67389H17.805C18.0038 2.67389 18.1363 2.80432 18.1363 2.99998C18.1363 3.19563 18.0038 3.32606 17.805 3.32606Z"
        fill="black"
      />
      <path
        d="M17.805 20.8696H16.1488C15.95 20.8696 15.8175 20.7391 15.8175 20.5435V18.913C15.8175 18.7174 15.95 18.5869 16.1488 18.5869C16.3475 18.5869 16.48 18.7174 16.48 18.913V20.2174H17.805C18.0038 20.2174 18.1363 20.3478 18.1363 20.5435C18.1363 20.7391 18.0038 20.8696 17.805 20.8696Z"
        fill="black"
      />
      <rect
        x="17.805"
        y="15.0652"
        width="1.65625"
        height="1.63043"
        fill="#ECECEC"
      />
      <path
        fillRule="evenodd"
        d="M17.8713 17.0217H19.5275C19.66 17.0217 19.8588 16.8913 19.8588 16.6957V15.0652C19.8588 14.8696 19.7263 14.7391 19.5275 14.7391H17.8713C17.6725 14.7391 17.54 14.8696 17.54 15.0652V16.6957C17.54 16.8913 17.6725 17.0217 17.8713 17.0217ZM19.13 16.3696H18.1363V15.3913H19.13V16.3696Z"
        fill="black"
      />
      <path
        d="M21.7138 16.5C21.515 16.5 21.3825 16.3696 21.3825 16.1739V15.3913H21.1838C20.985 15.3913 20.8525 15.2609 20.8525 15.0652C20.8525 14.8696 20.985 14.7391 21.1838 14.7391H21.7138C21.9125 14.7391 22.045 14.8696 22.045 15.0652V16.1739C22.045 16.3696 21.9125 16.5 21.7138 16.5Z"
        fill="black"
      />
    </svg>
  );
}
